import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import {  transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

// Create an API for dashboard tasks
const projectManagementAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'projectManagementAPI',
    endpoints: (builder) => ({

        getAllProjects: builder.query({
            query: () => ({
                url: `/Project/GetAllProjectList`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addProject: builder.mutation({
            query: (data) => ({
                url: `/Project/AddProject`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
      
        getAllProjectList: builder.mutation({
            query: (data) => ({
                url: `/Project/GetAllProjects`,
                method: 'POST',
                body: transformRequest(data), 
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteProject: builder.mutation({
            query: (data) => ({
                url: `/Project/DeleteProject?id=${data}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

       
        getProjectById: builder.query({
            query: (data) => ({
                url: `/Project/GetProjectById?projectId=${data}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    
        updateProject: builder.mutation({
            query: (data) => ({
                url: `/Project/UpdateProjectById`,
                method: 'POST',
                body: transformRequest(data), 
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getProjectDomain: builder.query({
            query: () => ({
                url: `/ProjectMaster/GetProjectMasterDomain`,
                method: 'GET',
            }),
           transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getProjectTypes: builder.query({
            query: () => ({
                url: `/ProjectMaster/GetMasterProjectTypes`,
                method: 'GET',
            }),
           transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllCustomer: builder.query({
            query: () => ({
                url: `/CustomerManagement/GetAllCustomer`,
                method: 'GET',
            }),
           transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getUserList: builder.query({
            query: () => ({
                url: `/User/GetAllUser`,
                method: 'GET',
            }),
           transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAssignProjectListByUserId: builder.query({
            query: (data) => ({
                url: `/Project/GetAssignProjectListByUserId?UserId=${data}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getUserAssignProjectsList: builder.query({
            query: (data) => ({
                url: `/Project/GetUserAssignProjectsList?UserId=${data}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),



    })
});

// Destructure hooks from projectManagementAPI API for usage
export const {
    useLazyGetAllProjectsQuery,
    useAddProjectMutation,
    useGetAllProjectListMutation,
    useDeleteProjectMutation,
    useLazyGetProjectByIdQuery,
    useUpdateProjectMutation,
    useLazyGetProjectDomainQuery,
    useLazyGetProjectTypesQuery,
    useLazyGetAllCustomerQuery,
    useLazyGetUserListQuery,
    useLazyGetAssignProjectListByUserIdQuery,
    useLazyGetUserAssignProjectsListQuery
} = projectManagementAPI;

export default projectManagementAPI; // Export projectManagementAPI API as default
